export default "__VITE_ASSET__Cu_aihpf__"